import { render, staticRenderFns } from "./ServiceTypeDetails.vue?vue&type=template&id=7d3ccfa7"
import script from "./ServiceTypeDetails.vue?vue&type=script&lang=js"
export * from "./ServiceTypeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports